
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { UserCircle2, Key, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LoginFormProps {
  loginIdentifier: string;
  setLoginIdentifier: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => void;
  switchToSignUp: () => void;
}

export const LoginForm = ({
  loginIdentifier,
  setLoginIdentifier,
  password,
  setPassword,
  isLoading,
  onSubmit,
  switchToSignUp
}: LoginFormProps) => {
  const { t } = useTranslation();

  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <div className="space-y-4">
        <div className="relative">
          <Input 
            type="text" 
            placeholder={t('auth.emailOrUsername')} 
            value={loginIdentifier} 
            onChange={e => setLoginIdentifier(e.target.value)} 
            required 
            className="pl-10 h-12 bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm 
                        border-primary/20 focus:border-primary focus:ring-2 focus:ring-primary/20 
                        transition-all duration-200" 
          />
          <UserCircle2 className="absolute left-3 top-3.5 h-5 w-5 text-primary/60" />
        </div>
        <div className="relative">
          <Input 
            type="password" 
            placeholder={t('auth.password')} 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
            required 
            className="pl-10 h-12 bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm 
                        border-primary/20 focus:border-primary focus:ring-2 focus:ring-primary/20 
                        transition-all duration-200" 
          />
          <Key className="absolute left-3 top-3.5 h-5 w-5 text-primary/60" />
        </div>
      </div>
      
      <Button 
        type="submit" 
        className="w-full h-12 text-base font-medium" 
        disabled={isLoading}
        size="mobile"
        fullWidth
      >
        {isLoading ? (
          <div className="flex items-center">
            <div className="h-5 w-5 mr-2 animate-spin rounded-full border-2 border-white border-r-transparent"></div>
            {t('auth.signingIn')}
          </div>
        ) : (
          <div className="flex items-center">
            {t('auth.login')}
            <ArrowRight className="ml-2 h-5 w-5" />
          </div>
        )}
      </Button>
      
      <div className="flex items-center justify-center w-full mt-4">
        <Button 
          type="button" 
          variant="outline" 
          className="text-sm py-2 px-4 w-full max-w-xs transition-all duration-200 hover:scale-105"
          onClick={switchToSignUp}
          size="sm"
          rounded="full"
        >
          {t('auth.needAccount')}
        </Button>
      </div>
    </form>
  );
};
